export default "__VITE_ASSET___juReEzk__"